<template
  ><v-dialog v-model="value" persistent max-width="30rem">
    <v-card class="pa-0">
      <v-toolbar flat color="primary" dark dense>
        <v-toolbar-title class="text-h6">
          {{ isEdit ? $t("portfolio.TagsItem.edit") : $t("portfolio.TagsItem.addNew") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="value = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form ref="tagForm" v-model="formValid">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  dense
                  counter
                  maxlength="20"
                  v-model="name"
                  :label="$t('portfolio.TagsItems.name')"
                  outlined
                  :rules="[
                    value => value.length >= 2 || $t('portfolio.TagsItems.nameMinLength'),
                    value => value.length <= 20 || $t('portfolio.TagsItems.nameMaxLength'),
                    value => !/\s/.test(value) || $t('portfolio.TagsItems.noSpaces')
                  ]"
                  @keydown.space.prevent
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <v-col
                    v-for="(color, index) in colors"
                    :key="index + color.backgroundColor + color.textColor"
                    cols="3"
                    class="d-flex justify-center pa-2"
                  >
                    <v-chip
                      :style="{
                        backgroundColor: $vuetify.theme.dark
                          ? color.textColor
                          : color.backgroundColor,
                        color: $vuetify.theme.dark ? color.backgroundColor : color.textColor,
                        border: activeColorId === color.id ? '1px solid grey' : 'none',
                        cursor: 'pointer',
                        width: '100%',
                        justifyContent: 'center'
                      }"
                      @click="activeColorId = color.id"
                    >
                      {{ $t("preview") }}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-col cols="12" class="d-flex justify-center">
                  <v-chip
                    :style="{
                      backgroundColor: $vuetify.theme.dark
                        ? previewTextColor
                        : previewBackgroundColor,
                      color: $vuetify.theme.dark ? previewBackgroundColor : previewTextColor
                    }"
                    class="ma-2"
                  >
                    {{ name || $t("preview") }}
                  </v-chip>
                </v-col>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" :disabled="!formValid" @click="submitTag">{{ $t("save") }}</v-btn>
          <v-btn text @click="value = false">{{ $t("cancel") }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text v-if="isEdit" color="error" @click="deleteTag">
            {{ $t("delete") }}
          </v-btn>

        </v-card-actions>
      </v-form>
    </v-card>
    <ConfirmActionDialogue
      ref="confirmActionDialog"
      :title="$t('portfolio.TagsItem.delete')"
      :description="$t('portfolio.TagsItem.confirmDelete')"
      @confirm="handleConfirmDeleteAction"
    /> </v-dialog
></template>

<script>
import ConfirmActionDialogue from "@/components/confirmActionDialog.vue";

export default {
  name: "TagItemDialog",
  components: {
    ConfirmActionDialogue
  },
  data() {
    return {
      colors: [],
      value: false,
      formValid: false,
      isEdit: false,
      previewTextColor: "#000000",
      previewBackgroundColor: "#FFFFFF",
      name: "",
      tagItemGuid: null,
      activeColorId: null
    };
  },
  created() {
    //this.getColors();

  },
  watch: {
    activeColorId(newVal) {
      const selectedColor = this.colors.find(color => color.id === newVal);
      if (selectedColor) {
        this.previewTextColor = selectedColor.textColor;
        this.previewBackgroundColor = selectedColor.backgroundColor;
      }
    }
  },
  methods: {
    deleteTag() {
      this.$refs.confirmActionDialog.showDialog();
    },
    handleConfirmDeleteAction() {
      this.axios
        .post("TagItem/Delete", { tagItemGuid: this.tagItemGuid })
        .then(() => {
          this.$emit("delete", this.tagItemGuid);
          this.value = false;
          this.clear();
        })
        .catch(error => {
          console.error("Error deleting tag:", error);
        });
    },
    async getColors() {
      try {
        const response = await this.axios.get("/TagItem/GetAllowedColors");
        this.colors = response.data.data;
      } catch (error) {
        console.error("Error fetching colors:", error);
      }
    },
    showDialog() {
      this.clear();
      this.isEdit = false;
      this.getColors().then(() => {
        this.value = true;
        this.activeColorId = 1;
        this.selectedColor = this.colors[0];
        this.previewTextColor = this.selectedColor.textColor;
        this.previewBackgroundColor = this.selectedColor.backgroundColor;
        if (this.$refs.tagForm) {
          this.$refs.tagForm.resetValidation();
        }
      });
    },
    showDialogEdit(tagItem) {
      this.clear();
      this.getColors().then(() => {
        const color = this.colors.find(
        x =>
          x.backgroundColor === tagItem.tagBackgroundColor && x.textColor === tagItem.tagTextColor
      );
      this.activeColorId = color.id;
      this.name = tagItem.tagName;
      this.previewTextColor = tagItem.tagTextColor;
      this.previewBackgroundColor = tagItem.tagBackgroundColor;
      this.tagItemGuid = tagItem.tagItemGuid;
      this.isEdit = true;
      this.value = true;
      if (this.$refs.tagForm) {
        this.$refs.tagForm.resetValidation();
      }
      });
     
    },
    clear() {
      this.name = "";
      this.activeColorId = 1;
      this.previewTextColor = "#000000";
      this.previewBackgroundColor = "#FFFFFF";
    },
    submitTag() {
      this.$refs.tagForm.validate();
      if (!this.formValid) return;

      if (this.isEdit) {
        this.axios
          .post("/TagItem/Update", {
            tagItemGuid: this.tagItemGuid,
            tagName: this.name,
            tagColorsPresetId: this.activeColorId
          })
          .then(() =>
            this.$emit("update", {
              tagItemGuid: this.tagItemGuid,
              tagName: this.name,
              tagBackgroundColor: this.previewBackgroundColor,
              tagTextColor: this.previewTextColor
            })
          )
          .catch(error => {
            console.error("Error updating tag:", error);
            this.$swal.fire({
              title: this.$t("AnErrorOccurredDuringTheProcess"),
              text: "",
              icon: "error",
              confirmButtonText: this.$t("close")
            });
          });
      } else {
        this.axios
          .post("/TagItem/Create", { tagName: this.name, tagColorsPresetId: this.activeColorId })
          .then(() => this.$emit("success"))
          .catch(error => console.error("Error adding tag:", error));
      }
      this.value = false;
    }
  }
};
</script>
